var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _setup.classList }, [
    _c("div", { staticClass: "subtitle" }, [_vm._v("FEATURES")]),
    _vm._v(" "),
    _c("h2", { staticClass: "mb-4" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.details))]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "b-button",
          { attrs: { variant: "alt-primary", to: { name: "individuals" } } },
          [_vm._v("\n      Buy\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }